import "promise-polyfill/src/polyfill";
import "./polyfills";
import "./assets/scss/main.scss";
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";

import VueForm from "vue-form";
import VueScrollTo from "vue-scrollto";

import Vuelidate from "vuelidate";
import VueParallaxJs from "vue-parallax-js";

import VueMeta from "vue-meta";
import VueGtm from "vue-gtm";

import "@bistudio/bohemia-vue-components/dist/BiTypography/BiTypography.css";
import "@bistudio/bohemia-vue-components/dist/BiGrid/BiGrid.css";
import "@bistudio/bohemia-vue-components/dist/BiIcon/BiIcon.css";

import Slick from "vue-slick";
Vue.component("slick", Slick);

Vue.use(VueMeta);
Vue.use(VueGtm, {
	id: "GTM-P75BL89", // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryPararms: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}]
	// queryParams: {
	// 	// Add url query string when load gtm.js with GTM ID (optional)
	// 	gtm_auth: "AB7cDEf3GHIjkl-MnOP8qr",
	// 	gtm_preview: "env-4",
	// 	gtm_cookies_win: "x"
	// },
	defer: true, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
	enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
	debug: false, // Whether or not display console logs debugs (optional)
	loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
	vueRouter: router, // Pass the router instance to automatically sync with router (optional)
	trackOnNextTick: false // Whether or not call trackView in Vue.nextTick
});

Vue.use(VueParallaxJs);
Vue.use(VueForm);
Vue.use(VueScrollTo);
Vue.use(Vuelidate);
Vue.config.productionTip = false;

router.beforeEach((from, to, next) => {
	store.commit("navigation/closeNav");
	next();
});
/* eslint-disable no-new */
new Vue({
	el: "#app",
	store,
	router,
	components: { App },
	template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js